export default "__VITE_ASSET__CpbSWq9i__"